module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jDtLc"))).then(() => module.bundle.root('ewmtE'));